import(/* webpackMode: "eager", webpackExports: ["BackButton"] */ "/app/apps/pickleball/src/components/Error/back-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopNavigationWrapper"] */ "/app/apps/pickleball/src/modules/top-navigation/TopNavigationWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.30_@babel+core@7.27.4_@opentelemetry+api@1.9.0_@playwright+test@1.51.0_react-_c90205548f2ac4db9f10a3f1e7ceb457/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorPage"] */ "/app/packages/features/src/error-pages/error-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainHeader"] */ "/app/packages/ui/src/components/global/Header/MainHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/src/components/global/platformStatsFooter/PlatformStatsFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui/src/components/global/platformStatsFooter/PlatformStatsFooterSkeleton.tsx");
